import { NgModule } from '@angular/core';

import { AppendToBodyDirective } from './append-to-body.directive';

@NgModule({
    declarations: [AppendToBodyDirective],
    exports: [AppendToBodyDirective],
})
export class AppendToBodyModule {}
